import { Component, OnInit, OnDestroy } from '@angular/core';
import { DirectionService } from '../../direction.service';
import { Subscription } from 'rxjs';
import { DialogService } from 'src/app/dialog/dialog.service';
import { Router } from '@angular/router';

import { NgForm } from "@angular/forms";
// import { FacebookLoginProvider, GoogleLoginProvider } from "@abacritt/angularx-social-login";

import { AuthService } from "../auth.service";
// import { set } from 'lodash';

@Component({
  selector: 'app-prelogin',
  templateUrl: './prelogin.component.html',
  styleUrls: ['./prelogin.component.css'],
  host: {
    class: 'fill-screen-modal'
  }
})

export class PreloginComponent implements OnInit, OnDestroy {
  isLoading: boolean = false;
  isDarkMode: boolean = false;
  isRTL: boolean = true;
  selectedLanguage: string = 'he';
  private directionSubscription: Subscription;
  loginStage: number = 0;
  private authStatusSub: Subscription;
  private emailCheckSubscription: Subscription;
  isEmailExists: string = '';
  email: string = '';

  signupHidePassword: boolean = true;
  loginHidePassword: boolean = true;
  passResetCodeHidePassword: boolean = true;
  passResetNewCode1HidePassword: boolean = true;
  passResetNewCode2HidePassword: boolean = true;

  passResetCode: string;
  isPassResetCodeSentToCheck: boolean = false;
  isPassResetCodeCorrect: boolean = false;
  newPass1: string;
  newPass2: string;
  isPassResetCodeAproved: boolean = false;
  resetToken: string = '';

  provider: string = '';
  hasPassword: boolean = false;

  constructor(
    private directionService: DirectionService,
    private dialogService: DialogService,
    private router: Router,
    public authService: AuthService
  ) {
    this.directionService.currentLanguage$.subscribe(lang => {
      this.selectedLanguage = lang;
    });
  };

  ngOnInit() {
    this.directionSubscription = this.directionService.direction$.subscribe(direction => {
      this.isRTL = direction === 'rtl';
    });

    this.directionService.isDarkMode$.subscribe(isDarkMode => {
      this.isDarkMode = isDarkMode;
    });

    this.authStatusSub = this.authService.getAuthStatusListener().subscribe(
      authStatus => {
        this.isLoading = false;
      }
    );
  }

  ngOnDestroy() {
    if (this.directionSubscription) {
      this.directionSubscription.unsubscribe();
    }
    if (this.authStatusSub) {
      this.authStatusSub.unsubscribe();
    }
  }

  closeLoginDialog() {
    this.dialogService.onCloseLoginDialog();
  }

  goToTandC() {
    this.router.navigate(["/tandc"]);
    this.closeLoginDialog();
  }
  goToPP() {
    this.router.navigate(["/pp"]);
    this.closeLoginDialog();
  }

  onEnterMail(form: NgForm) {
    if (form.invalid) {
      return;
    }
    this.isLoading = true;
    this.email = form.value.email;
    this.emailCheckSubscription = this.authService.checkEmail(form.value.email)
      .subscribe(
        (response: any) => {
          this.isEmailExists = response.exists;
          this.isLoading = false;
          if (this.isEmailExists) {
            this.provider = response.provider;
            // console.log("PROVIDER", this.provider);
            this.hasPassword = response.hasPassword;
            if (this.provider === 'local' || this.hasPassword) {
              // console.log("Local login");
              this.loginStage = 2;
            } else if (this.provider === 'facebook') {
              // console.log("Facebook login");
              this.signInWithFB();
              this.closeLoginDialog();
            } else if (this.provider === 'google') {
              // console.log("Google login");
              this.signInWithGoogle();
              this.closeLoginDialog();
            } else {
              // console.log("Other login");
              this.closeLoginDialog();
            }
          } else {
            this.loginStage = 3;
          }
        },
        (error) => {
          console.log("Error checking email:", error);
        }
      );
  }

  signInWithFB(): void {
    // this.authService.socialService.signIn(FacebookLoginProvider.PROVIDER_ID);
    this.authService.facebookLogin()
  }

  signInWithGoogle(): void {
    this.authService.googleLogin()
  }

  onLoginMail(form: NgForm) {
    if (form.invalid) {
      return;
    }
    this.isLoading = true;
    this.authService.login(this.email, form.value.password, 'local');
    this.isLoading = false;
  }

  onSignupMail(form: NgForm) {
    if (form.invalid) {
      return;
    }
    this.isLoading = true;
    this.authService.createUser(this.email, form.value.password, 'local');
    this.isLoading = false;
  }

  async toLoginStage(stage: number) {
    if (this.loginStage !== stage) {
      this.loginStage = stage;
      if (stage === 4) {
        await this.sendForgotPasswordEmail(this.email);
      }
    }
  }

  // toggle password view (EYE ICON)
  // login
  toggleLoginPasswordVisibility() {
    this.loginHidePassword = !this.loginHidePassword;
  }
  // Signup
  toggleSignupPasswordVisibility() {
    this.signupHidePassword = !this.signupHidePassword;
  }
  // PassResetCode
  togglePassResetCodeVisibility() {
    this.passResetCodeHidePassword = !this.passResetCodeHidePassword;
  }
  // pass01
  togglePassResetNewCode1Visibility() {
    this.passResetNewCode1HidePassword = !this.passResetNewCode1HidePassword;
  }
  // pass02
  togglePassResetNewCode2Visibility() {
    this.passResetNewCode2HidePassword = !this.passResetNewCode2HidePassword;
  }

  isIphone(): boolean {
    return /iPhone/.test(navigator.userAgent);
  }

  // password reset
  async sendForgotPasswordEmail(email: string) {
    this.isLoading = true;
    try {
      const response = await this.authService.onSendForgotPasswordEmail(email);
      if (response.message === 'WE_HAVE_SENT_YOU_INSTRUCTIONS_EMAIL') {
        this.isPassResetCodeSentToCheck = true;
      } else {
        this.isPassResetCodeSentToCheck = false;
        this.toLoginStage(1);
      }
      this.isLoading = false;
    } catch (error) {
      console.log("error: ", error);
      this.isPassResetCodeSentToCheck = false;
      this.toLoginStage(1);
      this.isLoading = false;
    }
  }

  async submitPassResetCode(passResetCode: string) {
    this.isLoading = true;
    try {
      const response = await this.authService.onSubmitPassResetCode(this.email, passResetCode);
      if (response.message === 'RESET_PASSWORD_CODE_MATCH' && response.token) {
        this.isPassResetCodeSentToCheck = false;
        this.isPassResetCodeCorrect = true;
        this.resetToken = response.token;
      } else {
        this.isPassResetCodeSentToCheck = false;
        this.isPassResetCodeCorrect = false;
        this.toLoginStage(1);
      }
      this.isLoading = false;
    } catch (error) {
      console.log("error: ", error);
      this.isPassResetCodeSentToCheck = false;
      this.isPassResetCodeCorrect = false;
      this.toLoginStage(1);
      this.isLoading = false;
    }
  }

  async resetPassword(newPass1: string, newPass2: string) {
    this.isLoading = true;
    try {
      if (newPass1 !== newPass2) {
        this.isLoading = false;
        return;
      }
      const response = await this.authService.onResetPassword(this.email, this.resetToken, newPass1);
      if (response.message === 'PASSWORD_RESET_SUCCESS') {
        this.isPassResetCodeCorrect = true;
        this.isPassResetCodeAproved = true;
        this.resetToken = '';
        this.isLoading = false;
        setTimeout(() => {
          this.isPassResetCodeAproved = false;
          this.isPassResetCodeSentToCheck = false;
          this.loginStage = 2;
        }, 2000);
      } else {
        this.isPassResetCodeCorrect = true;
      }
      this.isLoading = false;
    } catch (error) {
      console.log("error: ", error);
      this.isPassResetCodeCorrect = true;
      this.isLoading = false;
    }
  }

  // ==============
}
